<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Evaluaciones Sin Asignar</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
          <div class="row" style="margin-top:20px;">
            <div class="col-7"></div>
            <div class="col-4">
              <input type="text" placeholder="Buscar.." name="search" class="form-control" v-model="nombreEvaluadoBusqueda" v-on:keyup.enter="buscarEvaluaciones">
            </div>
            <div class="col-1 text-left">
              <button type="submit" class="form-control btn-sm btn-custom" @click="buscarEvaluaciones"><i class="fa fa-search"></i></button>
            </div>
          </div>
          <div class="row" style="margin-top:30px;">
            <div class="col-12">
              <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
                <thead class="thead-custom">
                  <tr>
                    <th>Número de Solicitud</th>
                    <th>Nombre</th>
                    <th>Puesto</th>
                    <th>Departamento</th>
                    <th>Tipo Contrato</th>
                    <th>Periodo de Evaluación</th>
                    <th>Fecha de Entrega</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class='text-dark'>
                  <tr v-for='evaluacion in evaluaciones'>
                    <td>#{{ evaluacion.SolicitudEvaluacionId }}</td>
                    <td>{{evaluacion.nombreEvaluado}}</td>

                    <td>{{evaluacion.Puesto}} <i v-if="evaluacion.AlertaHistorialLaboral" class="fas fa-exclamation-triangle" title="Problema de Historial Laboral. Favor de notificar a personal." /></td>
                    <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                    <td>{{evaluacion.TipoContrato}}</td>

                    <td>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                    <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                    <td class='d-flex justify-content-around'>
                      <i class='fa fa-comment' @click='Comentario(evaluacion.EvaluacionId)' title="Añadir Comentario" />
                    </td>
                  </tr>
                  <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones pendientes</td></tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>


    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>

    <!-- <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-7"></div>
          <div class="col-4">
            <input type="text" placeholder="Buscar.." name="search" class="form-control" v-model="nombreEvaluadoBusqueda" v-on:keyup.enter="buscarEvaluaciones">
          </div>
          <div class="col-1 text-left">
            <button type="submit" class="form-control" @click="buscarEvaluaciones"><i class="fa fa-search"></i></button>
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
              <thead class="thead-custom">
                <tr>
                  <th>Número de Solicitud</th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>Departamento</th>
                  <th>Tipo Contrato</th>
                  <th>Periodo de Evaluación</th>
                  <th>Fecha de Entrega</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='evaluacion in evaluaciones'>
                  <td>#{{ evaluacion.SolicitudEvaluacionId }}</td>
                  <td>{{evaluacion.nombreEvaluado}}</td>

                  <td>{{evaluacion.Puesto}} <i v-if="evaluacion.AlertaHistorialLaboral" class="fas fa-exclamation-triangle" title="Problema de Historial Laboral. Favor de notificar a personal." /></td>
                  <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                  <td>{{evaluacion.TipoContrato}}</td>

                  <td>{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                  <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-comment' @click='Comentario(evaluacion.EvaluacionId)' title="Añadir Comentario" />
                  </td>
                </tr>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones pendientes</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  import catalogos from '@/../static/js/catalogos'
  export default {
    data() {
      return {
        nombreEvaluadoBusqueda: "",//Contiene en valor del nombre del evaluado para busqueda
        evaluaciones: []
        
      }
    },
    components: {
      
    },
    methods: {
            
      buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "nombreEvaluadoBusqueda": this.nombreEvaluadoBusqueda,
          "estatusSolicitud": null,
          "EstatusEvaluacion": 4
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluaciones, peticion).then(response => {
          console.log(response.data);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            $("#alertaNumeroNomina").hide();//Oculta la alerta de número de nómina no válido (filtro de busqueda)
            this.evaluaciones = response.data.evaluaciones//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      Comentario: function (idEvaluacion) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
          name: 'DetalleEvaluacion',
          params: { idEvaluacion: idEvaluacion}
        })
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.buscarEvaluaciones()
    }

  }

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/EvaluacionesConcluidas.vue